import { delay } from 'lodash';
import React, { useEffect, useMemo } from 'react';
const TABLET_APP_ROUTES = {
  AUTH: {
    SIGN_IN: 'AUTH_SIGN_IN',
    CHOOSE_STORE: 'AUTH_CHOOSE_STORE',
  },
  STAFF: {
    DASHBOARD: 'STAFF_DASHBOARD',
    DETAIL: 'STAFF_DETAIL',
  },
  GIFT_CARD: {
    DASHBOARD: 'GIFT_CARD_DASHBOARD',
    QR_SCAN: 'GIFT_CARD_QR_SCAN',
  },
  DASHBOARD: {
    HOME: 'DASHBOARD_HOME',
    START_UP: 'DASHBOARD_START_UP',
  },
  CUSTOMER: {
    DASHBOARD: 'CUSTOMER_DASHBOARD',
  },
  REPORT: {
    TABS: 'REPORT_TABS',
    STAFF_DETAIL: 'REPORT_STAFF_DETAIL',
    PAYROLL_STAFF_DETAIL: 'REPORT_PAYROLL_STAFF_DETAIL',
    STAFF_DETAIL_PRINT_PREVIEW: 'REPORT_STAFF_DETAIL_PRINT_PREVIEW',
    INCOME_PRINT_PREVIEW: 'REPORT_INCOME_PRINT_PREVIEW',
    PAYROLL_PRINT_PREVIEW: 'REPORT_PAYROLL_PRINT_PREVIEW',
    TIMECLOCK_PRINT_PREVIEW: 'REPORT_TIMECLOCK_PRINT_PREVIEW',
  },
  TICKET: {
    DASHBOARD: 'TICKET_DASHBOARD',
    QUICK_VIEW: 'TICKET_QUICK_VIEW'
  },
  TURN: {
    DASHBOARD: 'TURN_DASHBOARD',
  },
  APPOINTMENT: {
    DASHBOARD: 'APPOINTMENT_DASHBOARD',
  },
  PAYMENT: {
    CASHIER: 'PAYMENT_CASHIER',
  },
  CREDIT_CARD: {
    DASHBOARD: 'CREDIT_CARD_DASHBOARD',
    DETAIL: 'CREDIT_CARD_DETAIL',
  },
  SETTING: {
    CONFIG: 'SETTING_CONFIG',
    SERVICE: 'SETTING_SERVICE',
    PRODUCT: 'SETTING_PRODUCT',
    VIP: 'SETTING_VIP',
    QUICK_PAY: 'SETTING_QUICK_PAY',
    TURN: 'SETTING_TURN'
  }
} as const;


enum IMessageTabletAppType {
  NAVIGATE = 'NAVIGATE',
  LOADED = 'LOADED',
}
type IMessageTabletApp = {
  type: IMessageTabletAppType,
  screen?: string;
  params?: any;
};
const useTabletApp = (loaded?: boolean) => {
  const usingForTabletApp = useMemo(() => location.href.includes('/tablet'), []);

  const postMessage = (body: IMessageTabletApp) => {
    // @ts-ignore
    window.ReactNativeWebView?.postMessage(JSON.stringify(body));
  };

  const navigate = (screen: string, params?: any) => {
    postMessage({ type: IMessageTabletAppType.NAVIGATE, screen, params });
  };

  const backtoHome = () => {
    navigate(TABLET_APP_ROUTES.DASHBOARD.HOME);
  };

  const cashierTicket = (billId: string) => {
    navigate(TABLET_APP_ROUTES.PAYMENT.CASHIER, {
      id: billId || '',
    });
  };

  useEffect(() => {
    if (!loaded) return;
    if (!usingForTabletApp) return;
    postMessage({ type: IMessageTabletAppType.LOADED });
  }, []);

  return ({ enable: usingForTabletApp, backtoHome, cashierTicket });
};

export default useTabletApp;
